import dayjs from 'dayjs';

type ScheduleDate = dayjs.Dayjs | Date | string;

export function getSlotLength(startDate: ScheduleDate, endDate: ScheduleDate) {
  const endDateHours =
    dayjs(endDate).get('hours') === 0 ? 24 : dayjs(endDate).get('hours');
  const diffHours = endDateHours - dayjs(startDate).get('hours');
  const diffMinutes =
    dayjs(endDate).get('minutes') - dayjs(startDate).get('minutes');

  const value = diffHours * 60 + diffMinutes;

  return value / 30;
}
